import { Component, OnInit, OnDestroy } from '@angular/core';
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';
import { BaseActionComponent } from './baseAction';


declare let $: any;
declare let Swal:any;

@Component({
    selector : 'removeItens-action',
    templateUrl:'removeItens.html'
})
export class removeItensActionComponent extends BaseActionComponent{

  public itens;
  public media
  public linkForm: FormGroup;
  public onClickAction=false;
  public text=''
  public level=1;

  public constructor(public translate: TranslationService,public _appData : AppDataService,public fb : FormBuilder, public _companyService : CompanyService) {
      super(translate,_appData,fb,_companyService)
  }
  public processData(action){
    if (!action){
      action={kind:'removeItens',param:{}}
    }
    let itemArray=[]
    this.itens.forEach(it=>{
      if (it.selected){
        itemArray.push(it.objectId)
      }
    })
    action.param.itens=itemArray
    action.param.room=this._appData.room.id;  
  }
  public selectItem(it) {
    this.media=null
    for (let i = 0; i < this.itens.length; i++) {
      if (this.itens[i].objectId == it.objectId) {
        this.itens[i].selected= this.itens[i].selected ? false : true 
      }
    }



  }  
  public childrenReloadData(){
    let action = this.action;
    let trigger=this._appData.activeTrigger;
    this._companyService.getUserRoomItemRef(this._appData.room.id).get().then(its=>{
      this.itens=[]
      its.forEach(it=>{
        let item=it.data();
        item.selected=false;
        if (action.param.itens){
          action.param.itens.forEach(sit=>{
            if (sit==item.objectId){
              item.selected=true;
            }
          })
        }
        this.itens.push(item)
      })
    })
  }
    public ngOnInit(): any {


    }


}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/actions/removeItens.ts